"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getInsufficientFundsContent = exports.INSUFFICIENT_FUNDS_CONTENT = void 0;
exports.INSUFFICIENT_FUNDS_CONTENT = {
    STANDARD: {
        RENT_TRACKER: {
            MAIN_TEXT: 'Your 1st payment failed',
            SUB_TEXT: 'We couldn’t complete your payment due to insufficient funds. You can make your payment now, or we’ll continue trying every {{retryHours}} until we notify you otherwise. The deadline to make your payment is {{bpEndDate}}.'
        },
        SERVICE_ISSUE_SCREEN: {
            HEADER: 'Your 1st payment failed',
            BOLD_MAIN_TEXT: 'We couldn’t complete your payment of {{paymentAmount}} due to insufficient funds. ',
            PRIMARY_CTA_TEXT: 'Pay now'
        }
    },
    SLC: {
        RENT_TRACKER: {
            MAIN_TEXT: 'Deposit not collected',
            SUB_TEXT: 'We couldn’t collect your deposit due to insufficient funds, but we’ll keep trying to process the payment.'
        },
        SERVICE_ISSUE_SCREEN: {
            HEADER: 'Deposit not collected',
            BOLD_MAIN_TEXT: 'We couldn’t collect your deposit of {{paymentAmount}} due to insufficient funds available. ',
            PRIMARY_CTA_TEXT: 'Make deposit'
        }
    },
    RENT_TRACKER: {
        CTA_TEXT: 'Pay now'
    },
    SERVICE_ISSUE_SCREEN: {
        MAIN_TEXT: 'We’ll try again every {{retryHours}} until we notify you otherwise. The deadline to make your payment is 3pm ET on {{bpEndDate}}.',
        SUB_TEXT: 'You can also make the payment now, or update your card details.',
        SECONDARY_CTA_TEXT: 'Update card'
    }
};
var getInsufficientFundsContent = function (_a) {
    var isEnabledForSLC = _a.isEnabledForSLC;
    var contentType;
    contentType = isEnabledForSLC ? 'SLC' : 'STANDARD';
    var content = __assign(__assign({}, exports.INSUFFICIENT_FUNDS_CONTENT), { RENT_TRACKER: __assign(__assign({}, exports.INSUFFICIENT_FUNDS_CONTENT.RENT_TRACKER), exports.INSUFFICIENT_FUNDS_CONTENT[contentType].RENT_TRACKER), SERVICE_ISSUE_SCREEN: __assign(__assign({}, exports.INSUFFICIENT_FUNDS_CONTENT.SERVICE_ISSUE_SCREEN), exports.INSUFFICIENT_FUNDS_CONTENT[contentType].SERVICE_ISSUE_SCREEN) });
    return content;
};
exports.getInsufficientFundsContent = getInsufficientFundsContent;
